var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.innerValue.isOverwriteVehicle,
              expression: "innerValue.isOverwriteVehicle",
            },
          ],
          staticClass: "is-checkradio",
          attrs: { id: "yes", type: "radio", name: "yes" },
          domProps: {
            value: true,
            checked: _vm._q(_vm.innerValue.isOverwriteVehicle, true),
          },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.innerValue, "isOverwriteVehicle", true)
            },
          },
        }),
        _c("label", { attrs: { for: "yes" } }, [_vm._v("Yes")]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.innerValue.isOverwriteVehicle,
              expression: "innerValue.isOverwriteVehicle",
            },
          ],
          staticClass: "is-checkradio",
          attrs: { id: "no", type: "radio", name: "no" },
          domProps: {
            value: false,
            checked: _vm._q(_vm.innerValue.isOverwriteVehicle, false),
          },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.innerValue, "isOverwriteVehicle", false)
            },
          },
        }),
        _c("label", { attrs: { for: "no" } }, [_vm._v("No")]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("span", [
        _vm._v(" Vehicle already exists. Overwrite vehicle's information? "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }